import data_catalog_image from '../../images/CatalogSearchBar2.png';
import '../DocumentationPages.css';
const SearchCatalogInfoView = () => {
  return (
    <div
      style={{
        backgroundColor: '#CEDBD6',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: '35px 10%',
      }}
    >
      <h4>Search and explore catalog</h4>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          alignItems: 'start',
        }}
      >
        <ol style={{ flex: '1 1 300px', margin: 0 }}>
          <li>
            <strong>Go to the Catalog Tab.</strong> Ensure you’re within the
            Catalog tab to access the datasets listings.
          </li>
          <li>
            <strong>Enter a Keyword in the Search Bar.</strong> Type the dataset
            name, category, or relevant keyword into the Search Bar to find
            specific items.
          </li>
          <li>
            <strong>Filter by Collection (optional).</strong> If desired, use
            the Filter by Collection option to narrow down your search to a
            specific collection or category.
          </li>
          <li>
            <strong>Click Search.</strong> Once you have entered your keyword
            and applied your desired filters, click the Search button to view
            your results.
          </li>
        </ol>
        <img
          className="imgDisplay"
          style={{
            height: '150px',
            width: 'auto',
            objectFit: 'contain',
          }}
          src={data_catalog_image}
          alt="Catalog Search"
        />
      </div>
    </div>
  );
};
const DownloadCatalogInfoView = () => {
  return (
    <div style={{ display: 'flex' }}>
      <div
        id="user_guide"
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          minWidth: '88%',
          flexGrow: 1,
          backgroundColor: '#CEDBD6',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              backgroundSize: 'cover',
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              padding: '35px 15% 35px 10%',
            }}
          >
            <h4>Download dataset from catalog</h4>
            <ol>
              <li>
                <strong>
                  Search for your desired dataset within the Catalog.
                </strong>{' '}
                See “Search and Explore catalog” section for more information.
              </li>
              <li>
                Click <strong>“Download (Zip/GeoJSON/GDB)”</strong> to download
                the dataset in one of the available formats. You will download a
                zipped file of the dataset onto your local computer. Unzip it to
                access the files.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SearchCatalogInfoView, DownloadCatalogInfoView };
